import React from 'react'
import styles from "../../../styles/components/UI/Custom/PermissionDenied.module.css"

export const PermissionDenied = ({ text }) => {
    return (
        <div className={styles.container} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh', fontSize: '24px', color: '#888' }}>
            {text}
        </div>
    )
}
